import i18n from '../../language/index'
import {
  create_title
} from '@/base/titleData';
import pageData from '@/base/pageData'

export default {
  img_effects: {
    id: 1,
    formData: {
      effect: 0,//当前选中的特效
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 2,
          borderColor: "rgba(0, 0, 0, 1)",
        },
        custom: {
          borderWidth: 2,
          borderColor: "rgba(0, 0, 0, 1)",
        }
      },
      background: {
        radio_val: 'default',
        default: {
          color: "rgba(255, 255, 255, 0)",
        },
        custom: {
          color: "rgba(255, 255, 255, 1)",
        }
      },
      direction: 'left'
    }
  },
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor: {
    marginTop: '0%',
    marginLeft: '0%',
    marginRight: '0%',
    marginBottom: '0%',
  },
  pc_widgets_infor: {
    //标题对象
    title: create_title(i18n.t('widgets_basic_job_edit_592')),
    page: pageData,

    // 字段label
    field_label: {
      radio_val: 'default',
      default: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fsWeight: 'bold',
        fontSize: 14,
        fontColor: 'rgba(122, 122, 122, 1)',
        fontFamily: 'Arial',
        textAlign: 'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 0
        },
      },
      custom: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 14,
        fsWeight: 'bold',
        fontColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign: 'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 0
        },
      }
    },
    // 字段内容
    field_content: {
      radio_val: 'default',
      default: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fsWeight: 'normal',
        fontSize: 14,
        fontColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign: 'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 0
        },
      },
      custom: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 14,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign: 'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 0
        },
      }
    },
    background: {
      radio_val: 'default',
      default: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinearGradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinearGradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    lineHeight: {
      radio_val: 'default',
      default: {
        lineHeight: 38
      },
      custom: {
        lineHeight: 58
      }
    },
    // 页面上显示'行高'，实际是改上下padding实现
    padding: {
      radio_val: 'default',
      default: {
        value: 15,
      },
      custom: {
        value: 15,
      }
    },
    splitLine: {
      radio_val: 'default',
      default: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 1,
        borderStyle: 'solid'
      },
      custom: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 0,
        borderStyle: 'solid'
      }
    },
    // 内容高度
    contentHeight: {
      radioVal: 'default',
      default: {
        height: 'auto'
      },
      custom: {
        height: '500px'
      }
    },
  },
  mb_widgets_infor: {
    //标题对象
    title: create_title(i18n.t('widgets_basic_job_edit_592')),
  },
  listArr: {
    module_style: 1,
    field: ["address", "jobType", "salary", "require", "endTime"], // 显示内容,默认全选
    jobs: [], // 选中的职位
  },
}



// WEBPACK FOOTER //
// ./src/widgets/basic_job/style.js